<script>
import metaInfo from '@/modules/mixins/metaInfo'
import CardsBlock from '@/components/organism/checkout/CardsBlock.vue'
import Vue from 'vue'
import { Stripe } from '@/api'

const stripe = Vue.observable(new Stripe())
export default {
    name: 'PaymentMethods',
    components: { CardsBlock },
    mixins: [metaInfo],
    computed: {
        stripe: () => stripe,
        pageTitle() {
            return this.$t('profile.pages.payment_methods')
        },
    },
    mounted() {
        this.stripe.init()
    },
}
</script>

<template lang="pug">
.payment-methods
    cards-block(:stripe="stripe" profile-view)
</template>

<style scoped lang="scss"></style>
